/**
 * atomberg-sheet.js
 *
 * Tiny controller for `<div data-atomberg-sheet>` panels rendered by the
 * `atomberg-sheet` snippet. Opens via `[data-atomberg-sheet-trigger="<id>"]`,
 * closes via `[data-atomberg-sheet-close]`, ESC, or overlay click.
 *
 * Exposes window.AtombergSheet = { open(id), close(id), toggle(id) } so other
 * scripts can drive it imperatively too.
 */
(function () {
  'use strict';

  /** @type {any} */
  var w = window;
  if (w._atombergSheetInit) return;
  w._atombergSheetInit = true;

  /** @type {Set<string>} */
  var openSheets = new Set();

  /**
   * @param {string} id Sheet id (matches the snippet `id` param)
   */
  function open(id) {
    var sheet = document.getElementById(id);
    if (!sheet || !sheet.hasAttribute('data-atomberg-sheet')) return;
    sheet.setAttribute('data-open', '');
    sheet.setAttribute('aria-hidden', 'false');
    openSheets.add(id);
    document.documentElement.setAttribute('data-atomberg-sheet-lock', '');
  }

  /**
   * @param {string} id Sheet id
   */
  function close(id) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    sheet.removeAttribute('data-open');
    sheet.setAttribute('aria-hidden', 'true');
    openSheets.delete(id);
    if (openSheets.size === 0) {
      document.documentElement.removeAttribute('data-atomberg-sheet-lock');
    }
  }

  /**
   * @param {string} id Sheet id
   */
  function toggle(id) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    if (sheet.hasAttribute('data-open')) close(id);
    else open(id);
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!(target instanceof Element)) return;

    var trigger = target.closest('[data-atomberg-sheet-trigger]');
    if (trigger) {
      e.preventDefault();
      var openId = trigger.getAttribute('data-atomberg-sheet-trigger');
      if (openId) open(openId);
      return;
    }

    var closer = target.closest('[data-atomberg-sheet-close]');
    if (closer) {
      var sheetEl = closer.closest('[data-atomberg-sheet]');
      if (sheetEl && sheetEl.id) close(sheetEl.id);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || openSheets.size === 0) return;
    var ids = Array.from(openSheets);
    var last = ids[ids.length - 1];
    if (last) close(last);
  });

  w.AtombergSheet = { open: open, close: close, toggle: toggle };
})();
